//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';

// TODO: PD-264381: Cleanup youtube_automatic_posting feature flag
export const getIsYouTubeAutomaticSchedulingEnabled = createHasFeatureSelector(
  FeatureNames.YoutubeAutomaticPosting,
);
